import type { FileError } from 'react-dropzone';

export const maxCSVFileSize = 10 * 1024 * 1024; // 10MB

export const fileSizeError: FileError = {
  code: 'file too large',
  message: `File is larger than ${maxCSVFileSize}MB`,
};
